import tw, { styled } from 'twin.macro';

export default styled.span((props) => [
  // props.bgColor && tw`bg-black`,
  /*
   * leading-none: reset the leading in case the tag is used inside of running text and must obey to the leading of the running text.
   */
  tw`bg-black rounded-full px-8 py-4 uppercase font-bold text-white text-xs leading-none`
]);
